<template>
	<component :is="dynamicComponent" :to="link" class="list-group-item list-group-header">
		<h6 class="mb-0 float-left"><slot></slot></h6>
		<b-icon icon="chevron-right" class="float-right" v-if="link"></b-icon>
	</component>
</template>

<script>
export default {
	props: {
		link: String
	},
	computed: {
		dynamicComponent() {
			if (this.link) {
				return "router-link";
			}
			return "div";
		}
	}
};
</script>
